<template>
  <div class="column is-12 has-text-centered">
    <h1 class="title is-1">Oeps...<br/>404 not found</h1>
  </div>
</template>

<script>

export default {
  name: 'notFound',
  components: {

  }
}
</script>
